module.exports = __webpack_public_path__ + "static/image/history/pc/202410.jpg?1728ca3f";